module.exports = __webpack_public_path__ + "static/media/Faster and More Transparent Collaboration on Field Reports.44067d70.png";